import { render, staticRenderFns } from "./Physical.vue?vue&type=template&id=ba36036e&scoped=true&"
import script from "./Physical.vue?vue&type=script&lang=js&"
export * from "./Physical.vue?vue&type=script&lang=js&"
import style0 from "./Physical.vue?vue&type=style&index=0&id=ba36036e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba36036e",
  null
  
)

/* custom blocks */
import block0 from "./Physical.vue?vue&type=custom&index=0&blockType=div&class=physical-form"
if (typeof block0 === 'function') block0(component)

export default component.exports